import Swiper,{Navigation} from "swiper";

Swiper.use([Navigation]);

export function initMainSlider(){

    const swiper = new Swiper('#main_slider', {
        loop:true,
        speed: 900,
        preloadImages:false,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation:{
            nextEl:'.swiper-main-next',
            prevEl:'.swiper-main-prev'
        },
        breakpoints: {
            0: {
                centeredSlides: true,
                roundLengths: true,
                loop: false,
                slidesPerView: 1.1,
                spaceBetween: 10
            },
            500:{
                slidesPerView: 1,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 40
            }
        }
    });

}